import React, { useEffect, useState } from 'react';
import Layout from '../../../components/common/pageLayout';
import Form from '../../../components/Production/Form/NewBuildingConfirmationOfVesselCompletionAndDelivery';
import { useLocation } from 'react-router-dom/cjs/react-router-dom.min';
import constant from '../../../constant';
import { toast } from 'react-toastify';
import { v2_projects, v2_ships } from '../../../actions/v2/projectAndVessel';
import {
    v3_fetchNewBuildingConfirmationOfVesselCompletionAndDeliveryFields,
    v3_submitNewBuildingConfirmationOfVesselCompletionAndDelivery,
} from '../../../actions/v3/productionForm';
import Swal from 'sweetalert2';

const NewBuildingConfirmationOfVesselCompletionAndDelivery = (props) => {
    const location = useLocation();
    const { data } = location.state || {};

    const [formDetail, setFormDetails] = useState({
        project: { value: '', options: [], error: '' },
        ship: { value: '', options: [], error: '' },
        shipOwner: { value: '', options: [], error: '' },
        shipType: { value: '', options: [], error: '' },
        portOfRegistry: { value: '', options: [], error: '' },
        officialNumber: { value: '', options: [], error: '' },
        classification: { value: '', options: [], error: '' },
        yearBuilt: { value: '', options: [], error: '' },
        dateOfKeelLaying: { value: '', error: '' },
        dateOfLaunching: { value: '', error: '' },
        dateOfDelivery: { value: '', error: '' },
        sideLetter: { value: '', error: '' },
        remark: { value: '', error: '' },
        declaration: { value: '', error: '' },
        finalSubmit: { value: false },
        date: { value: '', error: '' },
    });

    const [showLoader, setShowLoader] = useState(false);

    useEffect(() => {
        v2_projects().then((res) => {
            if (res.status) {
                setFormDetails((prev) => ({
                    ...prev,
                    project: { ...prev.project, options: res.result },
                }));
            }
        });
    }, []);

    useEffect(() => {
        if (formDetail.project.value) {
            v2_ships(null, formDetail.project.value).then((res) => {
                if (res.status) {
                    setFormDetails((prev) => ({
                        ...prev,
                        ship: { ...prev.ship, options: res.result },
                    }));
                }
            });
        } else {
            setFormDetails((prev) => ({
                ...prev,
                ship: { value: '', options: [] },
            }));
        }
    }, [formDetail.project.value]);

    useEffect(() => {
        const params = data ? JSON.parse(atob(data)) : null;
        if (params) {
            setShowLoader(true);
            v3_fetchNewBuildingConfirmationOfVesselCompletionAndDeliveryFields(params.PROJECT_ID, params.SHIP_ID)
                .then((res) => {
                    if (res.status) {
                        const { formDetails: serverForm } = res.result;
                        setFormDetails((prev) => ({
                            ...prev,
                            project: { ...prev.project, value: serverForm?.PROJECT_ID || '' },
                            ship: { ...prev.ship, value: serverForm?.SHIP_ID || '' },
                            date: { ...prev.date, value: serverForm?.DATE || '' },
                            portOfRegistry: { ...prev.portOfRegistry, value: serverForm?.PORT_OF_REGISTRY || '' },
                            officialNumber: { ...prev.officialNumber, value: serverForm?.OFFICIAL_NUMBER || '' },
                            classification: { ...prev.classification, value: serverForm?.CLASSIFICATION || '' },
                            yearBuilt: { ...prev.yearBuilt, value: serverForm?.YEAR_BUILT || '' },
                            dateOfKeelLaying: { ...prev.dateOfKeelLaying, value: serverForm?.DATE_OF_KEEL_LAYING || '' },
                            dateOfLaunching: { ...prev.dateOfLaunching, value: serverForm?.DATE_OF_LAUNCHING || '' },
                            dateOfDelivery: { ...prev.dateOfDelivery, value: serverForm?.DATE_OF_DELIVERY || '' },
                            sideLetter: { ...prev.sideLetter, value: serverForm?.SIDE_LETTER || '' },
                            finalSubmit: { value: Boolean(serverForm?.FINAL_SUBMITTED) },
                            siteManagerBy: { value: serverForm?.SITE_MANAGER_BY || '' },
                            siteManagerId: { value: serverForm?.SITE_MANAGER_ID || '' },
                            headOfProjectBy: { value: serverForm?.HEAD_OF_PROJECT_BY || '' },
                            headOfProjectId: { value: serverForm?.HEAD_OF_PROJECT_ID || '' },
                            remark: { value: serverForm?.REMARK || '' },
                            declaration: { value: serverForm?.DECLARATION || '' },
                        }));



                    } else {
                        toast.error('Failed to load form details.');
                    }
                })
                .catch(() => toast.error('Something went wrong while fetching.'))
                .finally(() => setShowLoader(false));
        }
    }, []);
    const onSubmit = async () => {
        const errors = [];

        const requiredFields = [
            { key: 'project', label: 'Select a project.' },
            { key: 'ship', label: 'Select a ship.' },
            { key: 'date', label: 'Enter a date.' },
        ];

        // If final submit, validate all except remark
        if (formDetail.finalSubmit.value) {
            requiredFields.push(
                { key: 'portOfRegistry', label: 'Enter port of registry.' },
                { key: 'officialNumber', label: 'Enter official number.' },
                { key: 'classification', label: 'Enter classification.' },
                { key: 'yearBuilt', label: 'Enter year built.' },
                { key: 'dateOfKeelLaying', label: 'Enter date of keel laying.' },
                { key: 'dateOfLaunching', label: 'Enter date of launching.' },
                { key: 'dateOfDelivery', label: 'Enter date of delivery.' },
                { key: 'sideLetter', label: 'Enter side letter.' },
                { key: 'declaration', label: 'Enter declaration.' }
            );
        }

        // Validate required fields
        requiredFields.forEach(field => {
            if (!formDetail[field.key]?.value) {
                errors.push(field.label);
            }
        });

        if (errors.length > 0) {
            toast.error(
                <div>
                    {errors.map((e, idx) => (
                        <div key={idx}>• {e}</div>
                    ))}
                </div>
            );

            return;
        }

        if (formDetail.finalSubmit.value) {
            const confirmResult = await Swal.fire({
                title: 'Are you sure?',
                text: 'Do you want to submit the reports for Office Review?',
                icon: 'warning',
                showCancelButton: true,
                confirmButtonText: 'Yes, submit it',
                cancelButtonText: 'Cancel',
            });

            if (!confirmResult.isConfirmed) return;
        }

        const payload = {
            formData: {
                project: formDetail.project.value,
                ship: formDetail.ship.value,
                shipOwner: formDetail.ship.options.find(item => item.ID == formDetail.ship.value)?.SHIP_OWNER_ID || '',
                shipType: formDetail.ship.options.find(item => item.ID == formDetail.ship.value)?.SHIP_TYPE_ID || '',
                portOfRegistry: formDetail.portOfRegistry.value,
                officialNumber: formDetail.officialNumber.value,
                classification: formDetail.classification.value,
                yearBuilt: formDetail.yearBuilt.value,
                dateOfKeelLaying: formDetail.dateOfKeelLaying.value,
                dateOfLaunching: formDetail.dateOfLaunching.value,
                dateOfDelivery: formDetail.dateOfDelivery.value,
                sideLetter: formDetail.sideLetter.value,
                remark: formDetail.remark.value, // Not validated even on final submit
                declaration: formDetail.declaration.value,
                date: formDetail.date?.value || '',
                finalSubmit: formDetail.finalSubmit.value,
            },
        };

        setShowLoader(true);
        v3_submitNewBuildingConfirmationOfVesselCompletionAndDelivery(payload)
            .then((res) => {
                setShowLoader(false);
                if (res.status) {
                    toast.success(res.result.message || 'Submitted successfully!');
                    props.history.push(constant.Authedcomponent.submittedNewBuildingConfirmationOfVesselCompletionAndDelivery.url);
                } else {
                    toast.error(res.error || 'Submission failed.');
                }
            })
            .catch((err) => {
                setShowLoader(false);
                toast.error('Submission failed.');
                console.error('Submit Error:', err);
            });
    };


    const handleChange = (e) => {
        
        const { name, value } = e.target;
        setFormDetails((prev) => ({
            ...prev,
            [name]: {
                ...prev[name],
                value: value,
                error: '', // Optional: Clear the error when the user changes input
            },
        }));
    };

    return (
        <Layout title="Confirmation of Vessel Completion and Delivery">
            <div className="row">
                <div className="col-lg-12">
                    <div className="card" id={1}>
                        <div className="card-body">
                            <div className="checklist-title-bx">
                                <div className="row">
                                    <div className="col-md-9">
                                        <div className="text-left">
                                            <h4>
                                                Confirmation of Vessel Completion and Delivery
                                            </h4>
                                            <p>
                                                THIS IS TO CONFIRM that a corporation organized and
                                                existing under the laws of
                                                Singapore, having its registered office at 460 Alexandra Road,
                                                #38-02 mTower, Singapore 119963, has successfully completed
                                                the supervision of the vessel, with particulars given below,
                                                with full compliance with the agreed Building Specifications,
                                                and with all applicable Classification &amp; Statutory
                                                certificates specified therein, do fulfil the requirements set
                                                out in the Site Supervision
                                            </p>
                                        </div>
                                    </div>
                                    <div className="col-md-3">
                                        <table className="table-bottom-sig table-top-sig">
                                            <tbody>
                                                <tr className="bottom-sig-tr2-box">
                                                    <td className="input-td">
                                                        <p className="s2">Date</p>
                                                    </td>
                                                    <td>
                                                        <p className="s1">
                                                            <input
                                                                type="date"
                                                                className="form-control"
                                                                value={formDetail.date.value}
                                                                onChange={(e) =>
                                                                    setFormDetails((prev) => ({
                                                                        ...prev,
                                                                        date: { ...prev.date, value: e.target.value },
                                                                    }))
                                                                }
                                                            />
                                                        </p>
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>

                            <Form
                                onChange={handleChange}
                                state={formDetail}
                                onSubmit={onSubmit}
                                isFinalSubmitting={formDetail.finalSubmit.value}
                                setIsFinalSubmitting={() => setFormDetails((prev) => ({
                                    ...prev,
                                    finalSubmit: { ...prev.finalSubmit, value: !prev.finalSubmit.value },
                                }))}
                            />
                        </div>
                    </div>
                </div>
            </div>
        </Layout>
    );
};

export default NewBuildingConfirmationOfVesselCompletionAndDelivery;
